import styled, { css } from 'styled-components'

import * as ds from '@bob/design-system'

export const Aside = styled.div`
  @media screen and (${ds.breakpoint.TABLET}) {
    margin-right: 30px;
  }

  @media not screen and (${ds.breakpoint.MOBILE_L}) {
    margin-right: 0px;
  }
`

export const Controls = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 35px;
  margin-top: 12px;

  @media screen and (${ds.breakpoint.TABLET}) {
    flex-direction: column;
  }
`

export const DesktopContainer = styled.div`
  display: none;

  @media screen and (${ds.breakpoint.TABLET}) {
    display: block;
  }
`

type HeadingProps = {
  children?: React.ReactNode
  color: string
  description?: string
  title: string
}

export function Heading({ children, color, description, title }: HeadingProps): React.ReactElement {
  return (
    <HeadingWrapper>
      <BrushTitle as="h1" $color={color}>
        {title}
      </BrushTitle>
      {description && <ds.styles.copy.Text1 as="h2">{description}</ds.styles.copy.Text1>}
      {children}
    </HeadingWrapper>
  )
}

function brushBackgroundTitle($color: string) {
  return ds.utils.svg.toDataUrl(ds.brush.full.FullBrush3, {
    width: 193,
    fill: $color,
  })
}

const BrushTitle = styled(ds.styles.heading.Title2)<{ $color: string }>`
  ${({ $color }) => {
    return css`
      background-image: url('${brushBackgroundTitle($color)}');
    `
  }}

  background-size: 460px auto;
  background-repeat: no-repeat;
  background-position: -110px top;
  padding-left: 40px;
  margin-left: -40px;

  @media screen and (${ds.breakpoint.TABLET}) {
    background-size: 590px auto;
    background-position: -159px top;
  }

  ${({ $color }) => {
    return css`
      background-image: url('${ds.utils.svg.toDataUrl(ds.brush.full.FullBrush3, {
        width: 193,
        fill: $color,
      })}');
    `
  }}
`

export const HeadingWrapper = styled.div`
  margin-top: 20px;

  ${ds.styles.copy.Text1} {
    margin-top: 20px;
    max-width: 400px;

    @media screen and (${ds.breakpoint.TABLET}) {
      max-width: 50%;
    }
  }
`

export const Item = styled.li`
  width: 100%;

  @media screen and (min-width: 600px) {
    width: 46%;
  }

  @media screen and (${ds.breakpoint.TABLET}) {
    width: 100%;
  }
`

export const Main = styled.div``

export const MobileContainer = styled.div`
  display: block;

  @media screen and (${ds.breakpoint.TABLET}) {
    display: none;
  }
`

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 50px 0 50px;
`

export const Wrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(1, 100%);

  @media screen and (${ds.breakpoint.TABLET}) {
    grid-template-columns: repeat(4, 25%);

    ${Aside} {
      grid-area: 1 / 1 / span 3 / span 2;
    }

    ${Main} {
      grid-area: 1 / 3 / span 3 / span 3;
    }
  }

  @media screen and (${ds.breakpoint.LAPTOP}) {
    grid-template-columns: 33% 1fr 1fr 1fr;

    ${Aside} {
      grid-area: 1 / 1 / span 3 / span 1;
    }

    ${Main} {
      grid-area: 1 / 2 / span 3 / span 3;
    }
  }

  @media screen and (min-width: 1240px) {
    grid-template-columns: repeat(4, 25%);

    ${Aside} {
      grid-area: 1 / 1 / span 3 / span 1;
    }

    ${Main} {
      grid-area: 1 / 2 / span 3 / span 3;
    }
  }
`

export const ScrollAnchor = styled.div`
  position: absolute;
  z-index: -1;
  top: -20px;

  @media screen and (${ds.breakpoint.TABLET}) {
    top: -65px;
  }
`
